<template>
  <section class="stages-how-to">
    <rwl-heading h="3" align="center" v-html="$t('webinars.stages_how_to_title')"></rwl-heading>

    <p v-html="$t('webinars.stages_how_to_description')">
    </p>

    <ul class="stages-how-to__list" v-html="$t('webinars.stages_how_to_list')">
    </ul>
    <p>
      <a target="_blank"
         :href="$t('webinars.stages_how_to_link_url')"
         v-html="$t('webinars.stages_how_to_link_title')"></a>
      <!--      <a href="#">Zobacz szczegóły na stronie Microsoft Teams</a>-->
    </p>
  </section>
</template>

<script>
  import {RwlHeading} from "@rawlplug/rawlplug-design-components-library"

  export default {
    name: "StagesHowTo",
    components: {
      RwlHeading
    }
  }
</script>
<style lang="scss">
  @import "stages-tabs";

  ul.stages-how-to__list {
    @include make-stages-features-list($color-rwl-blue-100, 1, 15px);
  }

</style>
<style lang="scss" scoped>
  @import "stages-tabs";

  .stages-how-to {
    padding: $stages-tabs-content-padding;
    font-size: $stages-tabs-content-font-size;
    line-height: $stages-tabs-content-line-height;

    a {
      color: $color-rwl-orange-100;
      transition: color ease-in-out 150ms;

      &:hover {
        color: $color-rwl-vermillion-100;
      }
    }


    .h4.heading-4 {
      margin-top: $spacing-6;
    }

    @media (min-width: $breakpoint-md-min) {
      padding: $stages-tabs-content-md-padding;
      max-height: 470px;
      overflow: auto;
    }

    @media (min-width: $breakpoint-xl-min) {
      max-height: 450px;
    }
  }
</style>
